import { Dictionary } from '../../../core';

export function addDictionaryParams(query: URLSearchParams, queryKey: string, filterChoices?: Dictionary<string[]>) {
  query.delete(queryKey);
  if (filterChoices && Object.entries(filterChoices).length > 0) {
    Object.entries(filterChoices).forEach(([key, values]) => {
      values.forEach(value => {
        query.append(`${queryKey}[${key}]`, value);
      });
    });
  }
}

export function addArrayParams(query: URLSearchParams, queryKey: string, values?: string[] | boolean[]) {
  // Deleting (avoid empty array in backend)
  query.delete(queryKey);
  // URLSearchParams do not handles array, ex: foo=bar1&foo=bar2
  if (Array.isArray(values)) {
    values.forEach(x => query.append(queryKey, x));
  }
}
